import { render } from "./newTruck.vue?vue&type=template&id=18387404&scoped=true"
import script from "./newTruck.vue?vue&type=script&lang=js"
export * from "./newTruck.vue?vue&type=script&lang=js"

import "./newTruck.vue?vue&type=style&index=0&id=18387404&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18387404"]])

export default __exports__